import { useEffect, useRef, useState } from "react";
import { Navigate, useParams } from "react-router-dom";
import ItemViewer from "../components/item/ItemViewer";
import { getItem } from "../data/catalog";
import useBodyLock from "../hooks/useBodyLock";
import useEscape from "../hooks/useEscape";
import useOverlay from "../hooks/useOverlay";
import { HOME_PATH } from "../routes";

export default function ItemPage() {
  const { id } = useParams();
  const { close } = useOverlay();
  const item = getItem(id);
  const [closing, setClosing] = useState(false);
  const closeTimer = useRef(null);
  const hoverTimer = useRef(null);
  const hoverArmed = useRef(false);
  const openedAt = useRef(Date.now());
  const dismiss = () => {
    if (closeTimer.current) return;
    setClosing(true);
    closeTimer.current = setTimeout(close, 160);
  };
  useEffect(() => () => {
    clearTimeout(closeTimer.current);
    clearTimeout(hoverTimer.current);
  }, []);

  useBodyLock("productOpen");
  useEscape(dismiss);

  if (!item) return <Navigate to={HOME_PATH} replace />;
  return <>
    <div className={`productBackdrop${closing ? " closing" : ""}`} aria-hidden="true"
      onClick={dismiss}
      onMouseEnter={() => {
        if (hoverArmed.current) hoverTimer.current = setTimeout(dismiss, 60);
      }}
      onMouseLeave={() => clearTimeout(hoverTimer.current)} />
    <ItemViewer key={item.id} item={item} onClose={dismiss} closing={closing}
      onMouseMove={() => {
        clearTimeout(hoverTimer.current);
        if (Date.now() - openedAt.current >= 160) hoverArmed.current = true;
      }}
      onMouseEnter={() => clearTimeout(hoverTimer.current)} />
  </>;
}
